import { Link, useLocation, useNavigate } from "react-router-dom";
import { LogOut, ShieldCheck, CalendarCheck } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (pathname === "/login") return null;

  return (
    <header className="sticky top-0 z-40 border-b border-surface-border bg-white/80 backdrop-blur">
      <div className="container-narrow flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img
            src="/logo-icon.png"
            alt="Mediversity"
            className="h-9 w-9 object-contain"
          />
          <div className="leading-tight">
            <div className="font-display text-base font-semibold text-ink-900">Mediversity</div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-ink-400">Video Platform</div>
          </div>
        </Link>

        {user && (
          <nav className="flex items-center gap-2 text-sm">
            <Link
              to="/"
              className={`hidden sm:inline-flex rounded-md px-3 py-1.5 font-medium ${pathname === "/" ? "bg-surface-muted text-ink-900" : "text-ink-600 hover:bg-surface-muted"}`}
            >
              课程库
            </Link>
            <Link
              to="/checkins"
              className={`inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 font-medium ${pathname === "/checkins" ? "bg-surface-muted text-ink-900" : "text-ink-600 hover:bg-surface-muted"}`}
            >
              <CalendarCheck className="h-3.5 w-3.5" />
              我的打卡
            </Link>
            {user.isAdmin && (
              <Link
                to="/admin"
                className={`inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 font-medium ${pathname.startsWith("/admin") ? "bg-surface-muted text-ink-900" : "text-ink-600 hover:bg-surface-muted"}`}
              >
                <ShieldCheck className="h-3.5 w-3.5" />
                管理
              </Link>
            )}
            <span className="ml-3 hidden text-xs text-ink-400 sm:inline">{user.displayName || user.username}</span>
            <button
              onClick={() => { logout(); navigate("/login"); }}
              className="ml-1 inline-flex items-center gap-1.5 rounded-md p-2 text-ink-400 transition hover:bg-surface-muted hover:text-ink-600"
              title="退出"
            >
              <LogOut className="h-4 w-4" />
            </button>
          </nav>
        )}
      </div>
    </header>
  );
}
